<div class="select-file-type">
  <wk-select>
    <select
      (ngModelChange)="onDropDownSelection($event)"
      [(ngModel)]="currentSelection"
      class="select-dropdown wk-field-select"
    >
      <option [ngValue]="null" selected disabled hidden>
        {{ 'APP.ACTIONS.SELECT_DOCUMENT_TYPE' | translate }}
      </option>
      <option
        *ngFor="let docType of allowedDocTypes"
        [ngValue]="docType"
        [attr.title]="docType.title | translate"
      >
        {{ docType.title | translate }}
      </option>
    </select>
    </wk-select
  >
</div>
<ng-container *ngIf="currentSelection !== null">
  <wk-forms
    [formId]="formId"
    [showCompleteButton]="false"
    [showSaveButton]="false"
    [showRefreshButton]="false"
    [showTitle]="false"
    [showValidationIcon]="false"
    (formLoaded)="formLoaded($event)"
  >
  </wk-forms>
</ng-container>
